// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseRolloutActionStatus } from './ResponseRolloutActionStatus';
import {
  ResponseRolloutActionStatusFromJSON,
  ResponseRolloutActionStatusFromJSONTyped,
  ResponseRolloutActionStatusToJSON,
  ResponseRolloutActionStatusToJSONTyped,
} from './ResponseRolloutActionStatus';

/**
 *
 * @export
 * @interface ResponseRolloutAction
 */
export interface ResponseRolloutAction {
  /**
   * AppliedClusterRolloutCount is the number of cluster copies of the
   * rollout that applied the action.
   * @type {number}
   * @memberof ResponseRolloutAction
   */
  appliedClusterRolloutCount?: number;
  /**
   *
   * @type {number}
   * @memberof ResponseRolloutAction
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseRolloutAction
   */
  requestedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseRolloutAction
   */
  requestedBy?: string;
  /**
   *
   * @type {ResponseRolloutActionStatus}
   * @memberof ResponseRolloutAction
   */
  status?: ResponseRolloutActionStatus;
  /**
   *
   * @type {string}
   * @memberof ResponseRolloutAction
   */
  type?: string;
}

/**
 * Check if a given object implements the ResponseRolloutAction interface.
 */
export function instanceOfResponseRolloutAction(
  value: object,
): value is ResponseRolloutAction {
  return true;
}

export function ResponseRolloutActionFromJSON(
  json: any,
): ResponseRolloutAction {
  return ResponseRolloutActionFromJSONTyped(json, false);
}

export function ResponseRolloutActionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutAction {
  if (json == null) {
    return json;
  }
  return {
    appliedClusterRolloutCount:
      json['appliedClusterRolloutCount'] == null
        ? undefined
        : json['appliedClusterRolloutCount'],
    id: json['id'] == null ? undefined : json['id'],
    requestedAt: json['requestedAt'] == null ? undefined : json['requestedAt'],
    requestedBy: json['requestedBy'] == null ? undefined : json['requestedBy'],
    status:
      json['status'] == null
        ? undefined
        : ResponseRolloutActionStatusFromJSON(json['status']),
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function ResponseRolloutActionToJSON(json: any): ResponseRolloutAction {
  return ResponseRolloutActionToJSONTyped(json, false);
}

export function ResponseRolloutActionToJSONTyped(
  value?: ResponseRolloutAction | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    appliedClusterRolloutCount: value['appliedClusterRolloutCount'],
    id: value['id'],
    requestedAt: value['requestedAt'],
    requestedBy: value['requestedBy'],
    status: ResponseRolloutActionStatusToJSON(value['status']),
    type: value['type'],
  };
}
